import React from "react";
import { TableCell, TableRow } from "@material-ui/core";
import { TableFooter } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
  footerCell: {
    fontSize: 14,
    fontWeight: "bolder",
    borderRight: "1px solid #e0e0e0"
  }
}));
const CustomTableBodyFooter = ({ metaData = {}, params = {}, data = [] }) => {
  const classes = useStyles();
  if (!data || data.length === 0) {
    return null;
  }
  if (params && Object.keys(params).length > 0) {
    return null;
  }
  return (
    <TableFooter className={classes.footerCell}>
      <TableRow>
        {Object.keys(metaData).map((key, i) => (
          <TableCell
            key={i}
            className={classes.footerCell}
            sx={{
              color: "text.warning",
              fontWeight: "bold"
            }}
          >
            {parseInt(metaData[key]) === -1 ? (
              <></>
            ) : (
              <>
                {metaData[key] === "Tổng tiền"
                  ? metaData[key]
                  : `${parseInt(metaData[key])?.toLocaleString("en-US") ||
                      0} VNĐ`}
              </>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableFooter>
  );
};
CustomTableBodyFooter.propTypes = {
  metaData: PropTypes.any,
  params: PropTypes.any,
  data: PropTypes.array
};
export default CustomTableBodyFooter;
